import { useEffect, useState, Fragment } from 'react'
import axios from 'axios'
import OrderPrint from '../../components/Card/OrderPrint'
import Loading from '../../components/Loading'
import { ReactComponent as IconView } from '../../assets/icon-view.svg'
import { ReactComponent as IconViewNot } from '../../assets/icon-viewnot.svg'
import { api, versao } from '../../config'
import { getHeaders } from '../../actions/localStorage'
import { PERIODOS_ENTREGA_FILTRO } from '../../constants/entregaPeriodos'

export default function ProductsReports({ reports, handleFind, clearReports, loading, generatePdfProductsReport, loja }) {

  const [initial, setInitial] = useState("")
  const [final, setFinal] = useState("")
  const [periodoEntrega, setPeriodoEntrega] = useState("")

  const [productView, setProductView] = useState(0)
  /** { key: string, pedido: object } carregado via GET /pedidos/admin/:id para o OrderPrint */
  const [printJob, setPrintJob] = useState(null)
  const [printLoadingKey, setPrintLoadingKey] = useState(null)

  const [loadingPDF, setLoadingPDF] = useState(false)

  useEffect(() => {
    clearReports();
  }, []);

  function validateDates() {
    if (!initial || !final) {
      alert("Selecione as datas inicial e final");
      return false;
    }

    const initialDate = new Date(initial);
    const finalDate = new Date(final);
    
    if (initialDate > finalDate) {
      alert("A data inicial não pode ser maior que a data final");
      return false;
    }

    // Limitar a consulta a no máximo 90 dias para evitar sobrecarga
    const diffTime = Math.abs(finalDate - initialDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays > 90) {
      alert("Por favor, selecione um período máximo de 90 dias para evitar sobrecarga do sistema");
      return false;
    }

    return true;
  }

  function reportFilters() {
    const filters = { initial, final }
    if (periodoEntrega) filters.shippingPeriod = periodoEntrega
    return filters
  }

  function handleGenerateReport() {
    if (validateDates()) {
      handleFind(reportFilters());
    }
  }

  function orderPrintKey(order) {
    return `${order.pedido._id}-${order.entrega._id}`
  }

  function handleOrderPrintClick(e, order) {
    e.preventDefault()
    e.stopPropagation()
    if (!loja) {
      alert('Sessão inválida. Faça login novamente.')
      return
    }
    const key = orderPrintKey(order)
    setPrintLoadingKey(key)
    axios.get(`${api}/${versao}/api/pedidos/admin/${order.pedido._id}?loja=${loja}`, getHeaders())
      .then((res) => {
        const pedido = res.data && res.data.pedido
        if (!pedido) {
          alert('Pedido não encontrado.')
          return
        }
        setPrintJob({ key, pedido })
      })
      .catch(() => {
        alert('Não foi possível carregar o pedido para impressão.')
      })
      .finally(() => {
        setPrintLoadingKey(null)
      })
  }

  function printDataForOrderPrint(pedido) {
    return {
      simpleId: pedido.simpleId,
      entrega: pedido.entrega,
      pedido,
      observation: pedido.observation
    }
  }

  function generatePdf() {
    if (!validateDates()) return;
    if (!loja) {
      alert('Sessão inválida. Faça login novamente.')
      return
    }
    
    setLoadingPDF(true)
    
    // Timeout para prevenir travamento
    const timeout = setTimeout(() => {
      setLoadingPDF(false);
      alert("A geração do relatório está demorando mais que o esperado. Tente novamente com um período menor.");
    }, 60000); // 60 segundos

    generatePdfProductsReport(reportFilters(), loja, (report) => {
      clearTimeout(timeout);
      setLoadingPDF(false);
      if (report && report.url) {
        window.open(`${api}/${report.url}`);
      } else {
        alert("Erro ao gerar o relatório. Tente novamente.");
      }
    })
  }

  return (
    <div className="report-section">
      <h3>Produtos a serem entregues</h3>
      <h2>Listagem dos pedidos com <span>Entrega Agendada.</span></h2>
      <div className="report-search report-search--products">
        <div className="input-search">
          <label>Do dia</label>
          <input type="date" name="date" autoComplete="new-password" placeholder="Do dia" onChange={(e) => setInitial(e.target.value)} />
        </div>
        <div className="input-search">
          <label>Ao dia</label>
          <input type="date" name="date" autoComplete="new-password" placeholder="Ao dia" onChange={(e) => setFinal(e.target.value)} />
        </div>
        <div className="input-search">
          <label>Período de entrega</label>
          <select value={periodoEntrega} onChange={(e) => setPeriodoEntrega(e.target.value)}>
            <option value="">Todos</option>
            {PERIODOS_ENTREGA_FILTRO.map((p) => (
              <option key={p.value} value={p.value}>{p.label}</option>
            ))}
          </select>
        </div>
        <button onClick={handleGenerateReport}>Gerar Relatório</button>
      </div>
      
      { (loading || loadingPDF) ? <Loading /> : (reports && (
          <div className="report-details products">
          <div className="product-list">
            { Object.keys(reports).map((item, index) => (
              <div className="product-item" key={item}>
                <div className="item-data" onClick={() => setProductView(productView === index+1 ? 0 : index+1)}>
                  <div>
                    <label>{reports[item].length}</label>
                    <span>{item}</span>
                  </div>
                  { productView === index+1 ? <IconViewNot className="button-view" width={24} /> : <IconView className="button-view" width={24} /> }
                </div>
                { productView === index+1 && (
                  <div className="item-details">
                    <h3>Entregas</h3>
                    {reports[item].map((order, indexOrder) => (
                      <Fragment key={`${order.pedido.simpleId}-${order.entrega._id}-${indexOrder}`}>
                        { printJob && printJob.key === orderPrintKey(order) && (
                          <OrderPrint
                            data={printDataForOrderPrint(printJob.pedido)}
                            cliente={printJob.pedido.cliente}
                            onClick={() => setPrintJob(null)}
                          />
                        )}
                        <div className="order-item">
                          <div>ID Pedido/Entrega <span>{order.pedido.simpleId}</span></div>
                          <div>Quem Envia <span>{order.entrega.shippingSender}</span></div>
                          <div>Quem Recebe <span>{order.entrega.shippingRecipient}</span></div>
                          <div>Agendada para <span>{order.entrega.shippingDate}</span></div>
                          <button
                            type="button"
                            className="view-order"
                            title="Visualizar resumo do pedido"
                            disabled={printLoadingKey === orderPrintKey(order)}
                            onClick={(e) => handleOrderPrintClick(e, order)}
                          >
                            <i className="fa fa-print"></i>
                          </button>
                        </div>
                      </Fragment>
                    ))}
                  </div>
                )}
              </div>
            )) }

            { Object.keys(reports).length > 0 ? <button type="button" className="generatePdf" onClick={generatePdf}>Imprimir Relatório</button> : <div className="notFound">Não há produtos a serem entregues!</div>}
          </div>
        </div>
      )) }
    </div>
  )
}